import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import CountUp from 'react-countup';
// icon
import Icon from '@mdi/react';
import { mdiCrown, mdiEmoticonHappy, mdiTrophy, mdiSeal } from '@mdi/js';


export default function Counter() {
  return (
    <>
      <section className='section counter-section'>
        <div className='bg-overlay'></div>
        <Container>
          <Row className='py-lg-5 g-4'>
            <Col sm={6} lg={3}>
              <Card className='card-hover counter-card mb-0 overflow-hidden'>
                <Card.Body className='text-center'>
                  <Icon path={mdiCrown} className='text-white icon-size-60 mb-2' />
                  <CountUp end={10} duration={8} suffix='K' enableScrollSpy className='h1 text-white fw-bold d-block' />
                  <div className='w-20 border border-1 mx-auto my-3'></div>
                  <p className='text-white fs-18 mb-0'>Premium Property</p>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} lg={3}>
              <Card className='card-hover counter-card mb-0 overflow-hidden'>
                <Card.Body className='text-center'>
                  <Icon path={mdiEmoticonHappy} className='text-white icon-size-60 mb-2' />
                  <CountUp end={8600} duration={8} suffix='+' enableScrollSpy className='h1 fw-bold text-white d-block' />
                  <div className='w-20 border border-1 mx-auto my-3'></div>
                  <p className='text-white fs-18 mb-0'>Happy Customer</p>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} lg={3}>
              <Card className='card-hover counter-card mb-0 overflow-hidden'>
                <Card.Body className='text-center'>
                  <Icon path={mdiTrophy} className='text-white icon-size-60 mb-2' />
                  <CountUp end={1200} duration={8} enableScrollSpy className='h1 fw-bold text-white d-block' />
                  <div className='w-20 border border-1 mx-auto my-3'></div>
                  <p className='text-white fs-18 mb-0'>Awward Winning</p>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} lg={3}>
              <Card className='card-hover counter-card mb-0 overflow-hidden'>
                <Card.Body className='text-center'>
                  <Icon path={mdiSeal} className='text-white icon-size-60 mb-2' />
                  <CountUp end={95} duration={8} enableScrollSpy className='h1 fw-bold text-white d-block' />
                  <div className='w-20 border border-1 mx-auto my-3'></div>
                  <p className='text-white fs-18 mb-0'>Years Experience</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}
